import UserPage from 'flarum/forum/components/UserPage';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import app from 'flarum/forum/app';
import PurchaseHistoryComponent from './PurchaseHistoryComponent';
import Select from 'flarum/common/components/Select';
import StoreItemUtils from '../utils/StoreItemUtils';
import Placeholder from 'flarum/common/components/Placeholder';
import { showIf } from '../utils/NodeUtil';
export default class HistoryPage extends UserPage {
  loading = false;
  record = null;
  filters = {};
  currentFilter = "all";
  oninit(vnode) {
    super.oninit(vnode);
    this.loadUser(m.route.param('username'));
    StoreItemUtils.getInstance().getFilterProviderDict(this.filters);
  }
  show(user) {
    super.show(user);
    this.loadData();
  }
  content() {
    return m("div", {
      className: "store-history-page-container"
    }, m("div", {
      class: "store-history-page-title"
    }, m(Select, {
      options: this.filters,
      value: this.currentFilter,
      onchange: this.changeFilter.bind(this)
    }), m("span", null)), m("div", {
      className: "store-history-page"
    }, showIf(this.loading, m(LoadingIndicator, {
      display: "block"
    }), showIf(!!this.record?.length, this.record?.map((item, index) => {
      return m(PurchaseHistoryComponent, {
        item: item,
        onSubmit: this.updateItem.bind(this),
        onDelete: this.itemHasDeleted.bind(this)
      });
    }), m(Placeholder, {
      text: app.translator.trans("xypp-store.forum.history.no_record")
    })))));
  }
  changeFilter(e) {
    this.currentFilter = e;
    this.record = null;
    this.loadData();
  }
  async loadData() {
    if (this.record != null) return;
    if (!this.user?.id()) return;
    if (this.loading) return;
    this.loading = true;
    m.redraw();
    let type = undefined;
    if (this.currentFilter != "all") {
      type = this.currentFilter;
    }
    this.record = await app.store.find("purchase-history", {
      id: this.user?.id(),
      type
    });
    this.loading = false;
    m.redraw();
  }
  itemHasDeleted(item) {
    if (this.record) this.record = this.record?.filter(i => i.id() != item.id());
    m.redraw();
  }
  updateItem(item) {
    if (!this.record) {
      this.record = [];
    }
    if (this.record.find(i => i.id() == item.id())) {
      this.record = this.record.map(i => i.id() == item.id() ? item : i);
    } else {
      this.record.push(item);
    }
    m.redraw();
  }
}
flarum.reg.add('xypp-store', 'forum/components/HistoryPage', HistoryPage);